import React, { Fragment, useState, useEffect, useMemo } from "react";
import {
  Button,
  Tab,
  Tabs,
  Alert,
  Modal,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { Heading, Widget, Export } from "../../../shared";
import { useQuery, gql, useLazyQuery } from "@apollo/client";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import "./style.scss";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FilterComponent from "./filter";
import AclPermission from "../../../lib/acl";
import ManulPayment from "../../../shared/manulPayment";
import Subscrib from "../../../page/profile/subscrib";
import paisa from "paisa.js";
import { MultiSelect } from "react-multi-select-component";
const PAYMENT_QUERY = gql`
  query getHistoryByadmin($startDate: String, $endDate: String) {
    getHistoryByadmin(obj: { startDate: $startDate, endDate: $endDate }) {
      orderCreationId
      razorpayPaymentId
      amount
      month
      type
      validity
      _id
      createdAt
      account_refId {
        email
      }
      profile_refId {
        _id
        userId
        name
      }
    }
  }
`;

const USER_LIST_QUERY = gql`
  {
    profile_list {
      name
      lastname
      ex_ServiceMan
      in_Service
      date_of_birth
      blood_group
      blood_donation
      contact
      whatsapp
      address
      post
      createdAt
      family {
        name
        relation
        blood_group
      }
      pin
      district
      email
      subscribed
      verificationtype
      _id
      account_refId {
        action
        _id
        role {
          _id
          name
        }
      }
      area
      date_of_marriage
      occupation
      subscribed
      userId

      docFile {
        filename
      }
      assetManagement {
        filename
      }
      group_refId {
        title
      }
    }
  }
`;

const USER_PAYMENT_HISTORY_QUERY = gql`
  query Payment_viewUser($id: ID!, $month: Date!) {
    Payment_viewUser(obj: { id: $id, month: $month }) {
      amount
      groupID
      mPayment
      month
      paymentMode
      profile_refId
      sessionId
      type
      validity
    }
  }
`;

const PaymentManagement = () => {
  const [paumentmessage, setpaumentmessage] = useState(true);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [paymentamount, setPaymentamount] = useState({
    amount: 0.0,
  });
  const [filterText, setFilterText] = React.useState("");
  const [filater, setfilter] = useState([]);
  const [total, setTotal] = useState({
    monthlytotal: 0,
    donation: 0,
    subscription: 0,
  });
  const [memberShip, seMemberShip] = useState(0);
  const [datess, setDate] = useState({
    firstDay: moment().clone().startOf("month").format("YYYY-MM-DD"),
    lastDay: moment().clone().endOf("month").format("YYYY-MM-DD"),
  });
  const [refetch, { loading, error, data }] = useLazyQuery(PAYMENT_QUERY);

  const [loadUserlist] = useLazyQuery(USER_LIST_QUERY, {
    //fetchPolicy: "network-only", // Used for first execution
    // nextFetchPolicy: "cache-first", // Used for subsequent executions
    onCompleted: (data) => {
      let opctionList = [];
      if (data.profile_list.length > 0) {
        data.profile_list.map((items, key) => {
          if (items.group_refId && items.group_refId.length > 0) {
            let roles = "";
            items.group_refId.map((gro, key) => {
              let re = roles.concat(gro.title);
              roles = re;
            });
            opctionList.push({
              value: items._id,
              label: `${items.userId}-${items.name}-${roles}`,
              userId: items.userId,
            });
            //setOptions(opctionList)
            roles = "";
          } else {
            opctionList.push({
              value: items._id,
              label: `${items.userId}-${items.name}`,
              userId: items.userId,
            });
            //setOptions(opctionList)
          }
        });
      }
      setOptions(opctionList);
    },
  });

  const [
    userPaymentHistory,
    {
      loading: userPaymentHistoryLoading,
      error: userPaymentHistoryError,
      data: userPaymentHistoryData,
    },
  ] = useLazyQuery(USER_PAYMENT_HISTORY_QUERY);

  const [manulPaymnet, setManulPaymnet] = useState(false);
  const filteredItems = filater.filter(
    (item) =>
      JSON.stringify(item).toLowerCase().indexOf(filterText.toLowerCase()) !==
      -1
  );

  const [paymentDate, setPaymentDate] = useState(
    moment().clone().startOf("month").format("YYYY-MM-DD")
  );

  useEffect(() => {
    loadUserlist();
    refetchd(
      moment().clone().startOf("month").format("YYYY-MM-DD"),
      moment().clone().endOf("month").format("YYYY-MM-DD")
    );
    // refetch({
    //   variables: {
    //     startDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
    //     endDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
    //   },
    // }).then((res) => {
    //   console.log(res.data.getHistoryByadmin);
    //   setfilter(res.data.getHistoryByadmin);
    // });
  }, []);
  // const { data, loading, error } = useQuery(
  //   PAYMENT_QUERY,

  //   {
  //     variables: { startDate: new Date(), endDate: new Date() },
  //     onCompleted: (data) => {

  //     },
  //   }
  // );
  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return `Error! ${error.message}`;

  const columns = [
    {
      name: "",
      cell: (row) => (
        <Link
          target="_blank"
          className="userPf"
          to={"/admin/userProfile/" + row.profile_refId?._id}
        >
          {" "}
          <i class="fa fa-user" aria-hidden="true"></i>
        </Link>
      ),
      sortable: true,
      width: 20,
    },

    {
      name: "createdAt",
      cell: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => <span> {row.profile_refId?.name} </span>,
    },
    {
      name: "User ID",
      selector: (row) => <span> {row.profile_refId?.userId} </span>,
    },
    {
      name: "Email",
      selector: (row) => <span> {row.account_refId?.email} </span>,
      width: 200,
    },
    {
      name: "month of sub",
      sortable: true,
      selector: (row) => <span> {row.month} </span>,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
    },
    {
      name: "Validity",
      selector: (row) => <span> {row.validity} Month</span>,
    },

    {
      name: "orderCreationId",
      cell: (row) => row.orderCreationId,
      sortable: true,
    },

    {
      name: "razorpayPaymentId",
      selector: (row) => row.razorpayPaymentId,
    },
    {
      name: "Type",
      selector: (row) => <div className={row.type}> {row.type}</div>,
    },
    {
      name: "Invoice",
      cell: (row) => (
        <Link to={"/invoice/" + row._id} target="_blank">
          <i class="fas fa-file-invoice"></i>
        </Link>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const refetchd = (firstDay, lastDay) => {
    refetch({
      variables: {
        startDate: firstDay,
        endDate: lastDay,
      },
    }).then((res) => {
      setfilter(res.data.getHistoryByadmin);
      widgetFilter(res.data.getHistoryByadmin);
    });
  };

  const widgetFilter = (arry) => {
    if (arry.length) {
      let total = [];
      let monthly = 0;
      let donation = [];
      let subscription = [];
      // arry.forEach((element) => {
      //   total.push(Number(element.amount.replace("₹", " ")));
      // });
      ///console.log(arry)

      arry.forEach((element) => {
        if (element.type === "monthly") {
          monthly += Math.trunc(Number(element.amount));
        }
      });

      // arry.forEach((element) => {
      //   if (element.type === "MemberShip") {
      //     subscription.push(Number(element.amount.replace("₹", " ")));
      //   }
      // });

      // arry.forEach((element) => {
      //   if (element.type === "Donation") {
      //     donation.push(Number(element.amount.replace("₹", " ")));
      //   }
      // });

      // let totals = total.reduce((a, b) => a + b);
      //let donations = donation.reduce((a, b) => a + b);
      // let subscriptions = subscription.reduce((a, b) => a + b);
      setTotal({
        monthlytotal: monthly,
        //  donation: donations,
        //  subscription: subscriptions,
      });
      //seMemberShip(members);
    }
  };

  const filterbyDate = () => {
    refetchd(datess.firstDay, datess.lastDay);
  };

  const dateChane = (d, type) => {
    const values = { ...datess };
    values[type] = moment(d).format("YYYY-MM-DD");
    setDate(values);
  };

  const updatePaymentDate = (date) => {
    let startdate = moment(date).format("YYYY-MM-DD");

    setPaymentDate(startdate);
    setPaymentamount({
      amount: 10000,
      type: "monthly",
    });
    userPaymentHistory({
      variables: {
        id: selected.value,
        month: new Date(paymentDate).toISOString(),
      },
    }).then((res) => {
      if (res.data.Payment_viewUser) {
        setpaumentmessage(false);
      }
    });
  };

  const handleSelectionChange = (selectedOptions) => {
    // Keep only the most recently selected item (the last one in the array)
    const newSelection = selectedOptions.slice(-1);
    userPaymentHistory({
      variables: {
        id: newSelection[0].value,
        month: new Date(paymentDate).toISOString(),
      },
    }).then((res) => {
      if (res.data.Payment_viewUser) {
        setpaumentmessage(false);
      }
    });
    setSelected(newSelection);
  };

  const procedtopayment = () => {
    refetchd(
      moment().clone().startOf("month").format("YYYY-MM-DD"),
      moment().clone().endOf("month").format("YYYY-MM-DD")
    );
  };
  return (
    <div className="tbl" id="membership-Manage">
      <AclPermission
        isActive={[
          "admin",
          "President",
          "VP, Sec, jt Sec, treasurer",
          "Counsilor",
        ]}
        showMessage={false}
      >
        <Heading title="Payment Management" />
        <div className="row">
          <div className="col-md-3">
            <Widget title="Monthly Membership" value={total.monthlytotal} />
          </div>
          <div className="col-md-3">
            <Widget title="Monthly Paid Members" value={memberShip} />
          </div>
          <div className="col-md-3">
            <Widget title="Monthly Donation" value={total.donation} />
          </div>
          <div className="col-md-3">
            <Widget title="Monthly subscription" value={total.subscription} />
          </div>
        </div>

        <div className="card mt-3">
          <div className="tableheader">
            <h4>
              <span>{datess.firstDay} </span>
              To
              <span>{datess.lastDay}</span>
            </h4>
            <div className="filterbyDate">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                placeholderText="Date of Marriage"
                selected={new Date(datess.firstDay)}
                onChange={(date, e) => dateChane(date, "firstDay")}
              />
              <DatePicker
                dateFormat="dd/MM/yyyy"
                placeholderText="Date of Marriage"
                selected={new Date(datess.lastDay)}
                onChange={(date, e) => dateChane(date, "lastDay")}
              />
              <button className="btn btn-primary" onClick={filterbyDate}>
                {" "}
                Search
              </button>
              <FilterComponent
                onFilter={(e) => setFilterText(e.target.value)}
                //onClear={handleClear}
                filterText={filterText}
              />
            </div>
            <Export obj={filteredItems} fileName="Payment " />

            <button
              type="button"
              class="add-btn btn btn-primary"
              onClick={() => setManulPaymnet(true)}
            >
              Cash Paymnet
            </button>
          </div>

          <DataTable
            pagination
            highlightOnHover
            columns={columns}
            data={filteredItems}
            //data={data ? data.getHistoryByadmin : []}
            //subHeaderComponent={subHeaderComponent}
          />

          <Modal show={manulPaymnet} onHide={() => setManulPaymnet(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Cash Paymnet</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <>
                <div className="date-selecter">
                  <label>select Date</label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Date of Marriage"
                    selected={new Date(paymentDate)}
                    onChange={(date, e) => updatePaymentDate(date)}
                  />
                </div>

                <div className="userlist">
                  <label>select user</label>
                  <MultiSelect
                    options={options}
                    value={selected}
                    onChange={(e) => handleSelectionChange(e)}
                    labelledBy="Select"
                    closeOnChangedValue={false}
                    hasSelectAll={false}
                  />
                </div>
                {paumentmessage ? "" : <div>this user is already paid</div>}

                {selected.length > 0 && paymentDate && paumentmessage && (
                  <div className="total">
                    <div>
                      <span> User Name{selected[0].label}</span>
                    </div>

                    <span>Month Of Payment : {paymentDate}</span>
                    <span>Subscription type: {paymentamount.type}</span>
                    <span>
                      {" "}
                      Amount : {paisa.formatWithSymbol(paymentamount.amount, 2)}
                    </span>

                    <span>
                      {" "}
                      Total:{paisa.formatWithSymbol(paymentamount.amount, 2)}
                    </span>
                  </div>
                )}
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setManulPaymnet(false)}
              >
                Close
              </Button>
              {selected.length > 0 &&
                paymentamount.amount &&
                paymentDate &&
                paumentmessage && (
                  <ManulPayment
                    amountt={paymentamount.amount}
                    validity={1}
                    date={paymentDate}
                    type={"monthly"}
                    profilerefId={selected[0].value}
                    paymentMode="cash"
                    group_id={selected[0].group_id}
                    event={(e) => {
                      procedtopayment();
                      setManulPaymnet(false);
                    }}
                  />
                )}
            </Modal.Footer>
          </Modal>
        </div>
      </AclPermission>
    </div>
  );
};

export default PaymentManagement;
